/* eslint-disable indent */
/* eslint-disable quotes */
/* eslint-disable object-property-newline */
import {
  useEffect, useState, Fragment
} from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Tr, Td } from "react-super-responsive-table";
import useModal from "hooks/useModal";
import AllAccountsModal from "./AllAccountsModal";
import { startCase } from "lodash";
import {  useSelector } from "react-redux";
import ReactTooltip from "react-tooltip";
import "./RecursiveTableRows.css";
import { Button } from "reactstrap";
import DetailsModal from "./DetailsModal";

const RecursiveTableRows = ({ data, filter, level = 0, agreements }) => {
  const { t } = useTranslation();
  const [selectedAgreement, setSelectedAgreement] = useState(null);
  const [viewAccounts, toggleViewAccounts] = useModal();
  const [modalAccounts, setModalAccounts] = useState({});
  const [showNested, setShowNested] = useState({});
  const [accounts, setAccounts] = useState([]);
  const accountTypes = useSelector((state) => state.tradingAccountReducer.accountTypes);
  const clientDetails = useSelector(
    (state) => state.clientReducer?.clientDetails
  );

  const [showDetailsModal, setShowDetailsModal] = useState(false);
const [selectedClient, setSelectedClient] = useState(null);

const toggleDetailsModal = () => {
  setShowDetailsModal(!showDetailsModal);
};

  const getAccountTypeTitle = (id, accountTypes) => {
    return accountTypes?.find((type) => type._id === id)?.title || "Unknown";
  };

  const toggleNested = (id) => {
    setShowNested((prev) => ({ 
      ...prev, 
      [id]: !prev[id] 
    }));
  };

  useEffect(() => {
    const selected = filter
      ? agreements?.find((agreement) => agreement._id === filter)
      : agreements?.[0];
    setSelectedAgreement(selected);
  }, [filter, agreements]);

  useEffect(() => {
    if (data?.childs?.length) {
      const filtered = data.childs.filter((account) => {
        return (
          !filter ||
          account.fx?.agrementId === filter ||
          account?.childs?.some(child => child.fx?.agrementId === filter)
        );
      });
      setAccounts(filtered);
    } else {
      setAccounts([]);
    }
  }, [data?.childs, filter]);

  const memberValues = selectedAgreement?.members?.find(
    (member) => member.customerId._id === data._id
  );

  const getColorByAccountType = (accountTypeId) => {
    if (!accountTypeId) return "#7f8c8d";
  
    let hash = 0;
    for (let i = 0; i < accountTypeId.length; i++) {
      hash = accountTypeId.charCodeAt(i) + ((hash << 5) - hash);
    }
  
    const hue = Math.abs(hash) % 360;
  
    const saturation = 65;
    const lightness = 55;
  
    return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
  };

  return (
    <>
      <Tr>
      <Td className="py-2 text-start">
        <div
          style={{
            marginLeft: `${level * 15}px`,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
          }}
          className="position-relative"
        >
          {accounts?.length > 0 && (
            <span
              // to="#"
              className={`mdi mdi-chevron-${showNested[data._id] ? "up" : "down"} dropdown-toggle-icon`}
              style={{ fontSize: "1.5rem" }}
              onClick={() => toggleNested(data._id)}
            />
          )}
          {/* <span className="mx-1"></span> */}
          <Link
            // to={`/clients/${data._id}/profile`}
            to="#"
            className={
              data?.fx?.isIb
                ? "ib-color"
                : data?.fx?.isClient
                  ? "client-color"
                  : "default-color"
            }
          >
            {startCase(`${data?.firstName} ${data?.lastName}`)}
          </Link>
        </div>
      </Td>

        {/* <Td className="py-2 text-start">{data?.email}</Td> */}
        {/* <Td className="py-2 text-start" style={{ color: "#17a2b8" }}>
          <Link to={clientDetails?.parentId?._id ? `/clients/${clientDetails?.parentId?._id}/profile` : `/clients/${data?.parent?._id}/profile`} style={{ color: "inherit" }}>
            {data?.parent?.firstName ?? clientDetails?.parentId?.firstName ?? null} {data?.parent?.lastName ?? clientDetails?.parentId?.lastName ?? null}
          </Link>
        </Td> */}
        <Td className="py-2 text-start">
          {data.fx?.isIb ? t("Sub IB") : t("Client")}
        </Td>
        <Td className="py-2">
          {memberValues?.values?.length ? (
            memberValues.values.map((v, idx) => {
              const tooltipId = `tooltip-${v.accountTypeId || idx}`;
              const title = getAccountTypeTitle(v.accountTypeId, accountTypes);
              return (
                <span
                  key={v.accountTypeId || idx}
                  data-tip
                  data-for={tooltipId}
                  style={{
                    padding: "2px 8px",
                    borderRadius: "10px",
                    marginRight: "6px",
                    display: "inline-block",
                    fontSize: "12px",
                    cursor: "pointer",
                  }}
                  className="table-number-hover"
                >
                  {v.commission}
                  <ReactTooltip id={tooltipId} place="top" effect="solid">
                    <div>
                      <strong>Account Type:</strong> {title}
                      <br />
                      <strong>Commission:</strong> {v.commission}
                    </div>
                  </ReactTooltip>
                </span>
              );
            })
          ) : (
            "-"
          )}
        </Td>
        
        <Td className="py-2">
          {memberValues?.values?.length ? (
            memberValues.values.map((v, idx) => {
              const tooltipId = `rebate-tooltip-${v.accountTypeId || idx}`;
              const title = getAccountTypeTitle(v.accountTypeId, accountTypes);
              return (
                <span
                  key={v.accountTypeId || idx}
                  data-tip
                  data-for={tooltipId}
                  style={{
                    hover: "black",
                    padding: "2px 8px",
                    borderRadius: "10px",
                    marginRight: "6px",
                    display: "inline-block",
                    fontSize: "12px",
                    cursor: "pointer",
                  }}
                  className="table-number-hover"
                >
                  {v.rebate}
                  <ReactTooltip id={tooltipId} place="top" effect="solid">
                    <div>
                      <strong>Account Type:</strong> {title}
                      <br />
                      <strong>Rebate:</strong> {v.rebate}
                    </div>
                  </ReactTooltip>
                </span>
              );
            })
          ) : (
            "-"
          )}
        </Td>

        {/* <Td className="py-2">
          {data.fx?.liveAcc?.length > 0 ? (
            <Link
              to="#"
              className="mdi mdi-eye font-size-18 py-0"
              onClick={() => {
                setModalAccounts(data.fx);
                toggleViewAccounts();
              }}
            />
          ) : t("No Accounts")}
        </Td> */}
        <Td className="py-2 text-start" style={{ color: "#17a2b8" }}>
          <Link to={clientDetails?.parentId?._id ? `/clients/${clientDetails?.parentId?._id}/profile` : `/clients/${data?.parent?._id}/profile`} style={{ color: "inherit" }}>
            {data?.parent?.firstName ?? clientDetails?.parentId?.firstName ?? null} {data?.parent?.lastName ?? clientDetails?.parentId?.lastName ?? null}
          </Link>
        </Td>
        <Td className="py-2">
          <Button
            color="info"
            size="sm"
            onClick={() => {
              setSelectedClient(data);
              setShowDetailsModal(true);
            }}
          >
            Show Details
          </Button>
        </Td>
      </Tr>

      {showNested[data._id] &&
        accounts.map((child) => (
          <Fragment key={child._id}>
            <RecursiveTableRows
              data={child}
              filter={filter}
              level={level + 1}
              agreements={agreements}
            />
          </Fragment>
        ))}

      <AllAccountsModal
        show={viewAccounts}
        toggle={toggleViewAccounts}
        accounts={modalAccounts}
      />
      <DetailsModal
        show={showDetailsModal}
        toggle={toggleDetailsModal}
        client={selectedClient}
      />
    </>
  );
};

export default RecursiveTableRows;